import {
  MAIN_BLUE,
  NO_THEME_RED,
  MAIN_GREEN_RISE,
  MAIN_RED_FALL,
  MAIN_DEEP_WHITE,
  MAIN_DEEP_BLUE,
  WHITE_f7f7f7,
  GRAY_6e6e6e,
  MAIN_DARK,
  NO_THEME_GREY,
  MAIN_GOLD,
  WHITE_e4e4e4,
  WHITE_ALPHA,
  THEME,
  MAIN_PRIMARY,
  WHITE_BG,
  WHITE_CARD_BORDER,
  DARK_BG,
  WHITE_LINE,
} from "../../constants/colors";

const defaultLightColorConfig = {
  H00: MAIN_DARK,
  H01: NO_THEME_GREY,
  H02: WHITE_e4e4e4,
  H03: WHITE_f7f7f7,
  H04: MAIN_DEEP_WHITE,
  H05: MAIN_DEEP_WHITE,
};

const WHITE_THEME = {
  theme: THEME.LIGHT,
  ...defaultLightColorConfig,
  common_gold: MAIN_GOLD,
  common_blue: MAIN_BLUE,
  common_rise: MAIN_BLUE,
  common_fall: NO_THEME_RED,
  common_bgc: WHITE_f7f7f7,
  container_bg: WHITE_e4e4e4,
  content_bg: MAIN_DEEP_WHITE,
  content_bg_special: MAIN_DEEP_WHITE,
  content_bg_active: WHITE_f7f7f7,
  text_white: MAIN_DARK,
  text_white_2: GRAY_6e6e6e,
  text_white_3: GRAY_6e6e6e,
  text_white_5: MAIN_DARK,
  text_reverse_white: MAIN_DEEP_WHITE,
  text_grey: GRAY_6e6e6e,
  text_grey_active: GRAY_6e6e6e,
  text_thin_title: GRAY_6e6e6e,
  text_thin_border: WHITE_e4e4e4,
  card_header_bg: WHITE_f7f7f7,
  card_header_bg_disabled: WHITE_e4e4e4,
  card_header_text: MAIN_DARK,
  grey_border: WHITE_e4e4e4,
  gery_bg: WHITE_f7f7f7,
  depth_bg_green: MAIN_GREEN_RISE,
  depth_bg_red: MAIN_RED_FALL,
  kline_button_text: GRAY_6e6e6e,
  kline_button_text_selected: MAIN_DEEP_WHITE,
  kline_button_bg_selected: MAIN_PRIMARY,
  dropdown_list_hover_bg: WHITE_f7f7f7,
  plain_select_bg_active: WHITE_f7f7f7,
  plain_select_text: NO_THEME_GREY,
  plain_select_text_active: MAIN_BLUE,
  card_split: WHITE_e4e4e4,
  colored_span_bg: WHITE_f7f7f7,
  colored_span_border: MAIN_BLUE,
  leverage_block_bg: WHITE_f7f7f7,
  leverage_block_border: MAIN_BLUE,
  leverage_block_border_rise: MAIN_BLUE,
  leverage_block_border_fall: NO_THEME_RED,
  leverage_block_text: MAIN_BLUE,
  tab_header_active: MAIN_DARK,
  vs_bg_rise: MAIN_BLUE,
  vs_text_rise: MAIN_DEEP_WHITE,
  vs_bg_fall: NO_THEME_RED,
  vs_text_fall: MAIN_DEEP_WHITE,
  standalone_table_header_text: GRAY_6e6e6e,
  inner_table_header_text: NO_THEME_GREY,
  input_bg: MAIN_DEEP_WHITE,
  input_bg_disabled: WHITE_e4e4e4,
  input_border: WHITE_e4e4e4,
  input_border_disabled: WHITE_e4e4e4,
  input_text: MAIN_DARK,
  input_addon: GRAY_6e6e6e,
  special_input_bg: WHITE_f7f7f7,
  side_span_text: GRAY_6e6e6e,
  side_span_bg: WHITE_f7f7f7,
  percent_span_text: GRAY_6e6e6e,
  percent_span_bg: MAIN_DEEP_WHITE,
  percent_span_text_active: MAIN_BLUE,
  percent_span_bg_active: MAIN_DEEP_WHITE,
  radio_inner_border: WHITE_e4e4e4,
  span_thin_border: WHITE_e4e4e4,
  common_table_row_text: MAIN_DARK,
  entrust_type_tab_background: MAIN_DEEP_WHITE,
  entrust_type_tab_border: WHITE_e4e4e4,
  condition_wrapper: WHITE_f7f7f7,
  header_bgc: MAIN_DEEP_WHITE,
  dropdown_bgc: MAIN_DEEP_WHITE,
  dropdown_menu_new: MAIN_DEEP_WHITE,
  dropdown_list_hover_new: WHITE_f7f7f7,
  dropdown_menu: MAIN_DEEP_WHITE,
  dropdown_menu_text: MAIN_DEEP_BLUE,
  language_border: WHITE_e4e4e4,
  new_dropdown_list_hover_bg: "#F2F2F2",
  language_boxshadow: WHITE_e4e4e4,
  login_btn: MAIN_BLUE,
  // dropdown_bgc: WHITE_F5F4F4,
  // dropdown_menu: WHITE_F5F4F4,
  // dropdown_list_hover_bg: MAIN_DEEP_WHITE,
  kline_time_text: "#212833",
  kline_time_title: "#9EA7B7",
  kline_time_hover_text: "#212833",
  kline_time_hover_bgc: "#EFF1F1",
  scroll_bar_alpha: WHITE_ALPHA,
  table_header_bg: WHITE_BG,
  table_header_border: WHITE_CARD_BORDER,
  line_content_bg: WHITE_BG,
  line_content_border: WHITE_CARD_BORDER,
  line_start: "#9AA3A3",
  kline_time_text_color: DARK_BG,
  line_color: WHITE_LINE,
};

export default WHITE_THEME;
